import React, { useState, useEffect } from 'react';
import Navbar from '../../../ReusableBlocks/Navbar';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import { useSnackbar } from 'notistack';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
//import { useDemoCatalog, useNarrativeDetails } from '../../../Redux/Dashboard/External/Demo_Catalgue/DemoCatlagueAction'; // Adjust path as needed
import { fetchDemoCatalog } from '../../../Redux/Dashboard/External/Demo_Catalgue/DemoCatlagueAction';
import { narrativeSearch } from '../../../Redux/Dashboard/External/Search/NarrativeSearchAction'
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import CryptoJS from 'crypto-js';
import * as PATH from '../../../CentralisedLink'
import { normalizeMediaUrl } from '../../../Utils/mediaUrls';
import { useFeatureFlags } from '../../../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../../../FeatureFlags/featureFlagConstants';

import { fetchSales } from '../../../Redux/Dashboard/External/SalesDemo/Actions/SalesPersonaHomAction';
import { clearExistingDemoSession } from '../../../Redux/Dashboard/External/SalesDemo/Actions/FetchExistingDemoSessionAction';
import { createInternalDemoSessionAct, clearcreateDemoSession } from '../../../Redux/Dashboard/External/SalesDemo/Actions/CreateDemoSessionAction';




// Loading Spinner Component
const LoadingSpinner = () => (
  <div className="spinner">
    <div className="double-bounce1"></div>
    <div className="double-bounce2"></div>
  </div>
);


const Demo_Catalaugue = (props) => {
  const navigate = useNavigate();

  const secretKey = 'narrative';
  const { enqueueSnackbar } = useSnackbar();


  const encryptId = (id) => {
    const ciphertext = CryptoJS.AES.encrypt(id, secretKey).toString();
    return encodeURIComponent(ciphertext);
  };



  const dispatch = useDispatch();
  const { isFeatureEnabled } = useFeatureFlags();
  const enableSalesDemo = isFeatureEnabled(FEATURE_FLAGS.EnableSalesDemo);
  const { demoCatalog } = useSelector(state => state.Demo_Catalgue);
  const isLoading = useSelector(state => state.Demo_Catalgue?.demoCatalog?.isLoading);
  const errorMessage = useSelector(state => state.Demo_Catalgue?.demoCatalog?.error);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('narrative');

  // Search Result 
  const serResult = useSelector(state => state.NarrativeSearch?.results);
  const serError = useSelector(state => state.NarrativeSearch?.error);
  const serLoading = useSelector(state => state.NarrativeSearch?.loading);


  const hotNarratives = demoCatalog?.data?.['hot-narratives'] || [];

  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPlaybookModalOpen, setIsPlaybookModalOpen] = useState(false);
  const [selectedPlaybooks, setSelectedPlaybooks] = useState([]);
  const [selectedPlaybook, setSelectedPlaybook] = useState(null);

  useEffect(() => {
    dispatch(fetchDemoCatalog());
  }, [dispatch]);


  useEffect(() => {
    console.log(serResult.result)
    if (serResult.result?.length > 0) {
      setSearchResults(serResult.result);
      setIsSearchActive(true);
    } else if (!serLoading && !serError) {
      setSearchResults([]);
      setIsSearchActive(true);
    }

    if (serError) {
      enqueueSnackbar('Failed to fetch search results.', { variant: 'error' });

    }
  }, [serResult.result, serLoading, serError]);


  useEffect(() => {
    // Reset the search state whenever the route changes
    setSearchQuery('');
    setSearchResults([]);
    setIsSearchActive(false);
  }, [location]);

  // Cleanup search state when unmounting
  useEffect(() => {
    return () => {
      setSearchQuery('');
      setSearchResults([]);
      setIsSearchActive(false);
    };
  }, []);

  // Tenent UPdate Status
  useEffect(() => {
    if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessage]);



  // Search Error
  useEffect(() => {
    if (serError) {
      Swal.fire({
        title: 'Error',
        text: serError,
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Try to refresh page',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [serError]);



  const handleSearchInputChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (!query) {
      setIsSearchActive(false);
      setSearchResults([]);
    }
  };

  const handleShowAll = () => {
    setIsSearchActive(false);
    setSearchResults([]);
    setSearchQuery('');
  };

  const handlePlaybookClick = (playbook) => {
    if (Array.isArray(playbook) && playbook.length > 1) {
      setSelectedPlaybooks(playbook);
      setIsModalOpen(true);
    } else if (Array.isArray(playbook) && playbook.length === 1) {
      setSelectedPlaybook(playbook[0]);
      setIsPlaybookModalOpen(true);
    } else if (playbook) {
      setSelectedPlaybook(playbook);
      setIsPlaybookModalOpen(true);
    }
  };

  const handlePlaybookSelection = (playbook) => {
    setSelectedPlaybook(playbook);
    setIsModalOpen(false);
    setIsPlaybookModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPlaybook(null);
    setSelectedPlaybooks([]);
  };

  const closePlaybookModal = () => {
    setIsPlaybookModalOpen(false);
    setSelectedPlaybook(null);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        enqueueSnackbar('Password copied to clipboard!', { variant: 'success' });
      })
      .catch(() => {
        enqueueSnackbar('Failed to copy Password.', { variant: 'error' });
      });
  };




  const handleSearchSubmit = (e) => {
    e.preventDefault();

    if (!searchQuery.trim()) {
      enqueueSnackbar('Please enter a search term.', { variant: 'error' });
      return;
    }

    dispatch(narrativeSearch(searchQuery));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearchSubmit(e); // Pass the event object here
    }
  };

  const narrativesToDisplay = isSearchActive ? searchResults : (demoCatalog?.data?.['available-narratives'] || []);
  console.log(narrativesToDisplay)






  const salesPersonaResult = useSelector(state => state.SalesPersonaHomepage?.salesData);

  // useEffect
  useEffect(() => {
    // Clear ExistingDemoSession when the component is mounted
    dispatch(clearExistingDemoSession());
    dispatch(clearcreateDemoSession());
  }, [dispatch]);


  useEffect(() => {
    if (!enableSalesDemo && activeTab === 'sales') {
      setActiveTab('narrative');
    }
  }, [enableSalesDemo, activeTab]);

  //  Fetching Sales Personas
  useEffect(() => {
    if (!enableSalesDemo) {
      return;
    }

    dispatch(fetchSales());
  }, [dispatch, enableSalesDemo]);


  // Functions
  const handleShowSalesFormModel = async (personaId, title) => {



    const internalParams = {
      demoPurpose: 'Demo Practice',
    };


    console.log(internalParams)

    try {
      await dispatch(createInternalDemoSessionAct(personaId, internalParams));
      navigate(`${PATH.SALES_DASHBOARD_PATH}${encodeURIComponent(title)}`);
    } catch (error) {
      console.error('Error creating internal session:', error);
      alert('Failed to create an internal session.');
    }



  };
















  return (
    <>
      {isLoading && <LoadingScreen text="Getting All Narratives" />}

      <Navbar activeTab={"DEMO_CATALGUE"} />

      {/* Demo Catalgue Page Start From Here */}
      <div className='background-demo-catalgue'>
        {/* <br /> */}
        <div className='container'>

          <br />

          <div>


            {/* Tabs {Narratives and Sales Demos} */}
            <div className="demo-cat-tab-wrapper">
              <button
                className={`demo-cat-tab-button ${activeTab === 'narrative' ? 'active' : ''}`}
                onClick={() => setActiveTab('narrative')}
              >
                Narrative
              </button>
              {enableSalesDemo && (
                <>
                  <div className="demo-cat-tab-divider"></div>
                  <button
                    className={`demo-cat-tab-button ${activeTab === 'sales' ? 'active' : ''}`}
                    onClick={() => setActiveTab('sales')}
                  >
                    Sales Demos
                  </button>
                </>
              )}
            </div>


            {activeTab === 'narrative' || !enableSalesDemo ? (

              <div>
                {!serLoading && !isSearchActive && (
                  <>
                    <div className="hot-narratives-container">
                      <div>
                        <h1 className='hot-narra-h1-cat'>Try these Hot Narratives</h1>
                        <p className='hot-narra-p'>
                          A carefully selected compilation of demos that have garnered widespread popularity
                        </p>
                      </div>
                      {/* Hot Narratives Search Bar */}
                      <div className="master-display-two-end-sec">
                        <div class="search-form-demo-catalgue">
                          <input
                            className="input-box-search-box-2"
                            type="text"
                            placeholder="Search narratives here"
                            value={searchQuery}
                            onKeyDown={handleKeyDown}
                            onChange={handleSearchInputChange}
                          />
                          <button type="submit" onClick={handleSearchSubmit}>
                            <i class="fa-solid fa-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Hot Narrtices */}
                    <div className='row'>
                      {hotNarratives.map((narrative, index) => (
                        <div key={index} className="col-md-4 mb-3">
                          <div className="home-card">
                            <div
                              className='card-image-sec' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(narrative.thumnail, 'background')})` }}
                            >
                              <h6 className='card-titile-catlague'>{narrative.title}</h6>
                            </div>

                            <div className="contained">
                              <p className='card-p-cata'>
                                {narrative.shortDescription}
                              </p>
                              <div className="card-btn-sec-new">
                                <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`}>
                                  <button className='card-cat-btn1'>View Details</button>
                                </Link>
                                {narrative?.playbook ? (
                                  <button className='card-cat-btn2' onClick={() => handlePlaybookClick(narrative.playbook)}>
                                    Playbook <i className="fa-solid fa-book"></i>
                                  </button>
                                ) : null}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                      ))}



                    </div>


                  </>
                )}




                <div className="hot-narratives-container">
                  <div>
                    <h1 className='hot-narra-h1-cat'>All Available Narratives</h1>
                    <p className='hot-narra-p'>
                      A carefully selected compilation of demos that have garnered widespread popularity
                    </p>
                  </div>


                  {/* All Availbale search bar */}
                  <div className="master-display-two-end-sec">
                    {isSearchActive && (
                      <div class="search-form-demo-catalgue">
                        <input
                          className="input-box-search-box-2"
                          type="text"
                          placeholder="Search narratives here"
                          value={searchQuery}
                          onKeyDown={handleKeyDown}
                          onChange={handleSearchInputChange}
                        />
                        <button type="submit" onClick={handleSearchSubmit}>
                          <i class="fa-solid fa-arrow-right"></i>
                        </button>
                      </div>
                    )}
                  </div>
                </div>


                {serLoading && <LoadingSpinner />}
                {serError && <p>Error: {serError}</p>}

                <div className="row">
                  {!serLoading && narrativesToDisplay.length > 0 ? (
                    narrativesToDisplay.map(narrative => {
                      // Ensure the narrative has a consistent _id field
                      const narrativeId = narrative._id || narrative.id;

                      return (
                        <div className="col-md-4 mb-3" key={narrativeId}>
                          <div className="home-card">
                            <div className='card-image-sec' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(narrative.thumbnail, 'background')})` }}>
                              <h6 className='card-titile-catlague'>{narrative.title}</h6>
                            </div>

                            <div className="contained">
                              <p className='card-p-cata'>
                                {narrative.shortDescription}
                              </p>
                              <div className="card-btn-sec-new">
                                <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrativeId)}`}>
                                  <button className='card-cat-btn1'>View Details</button>
                                </Link>
                                {narrative?.playbook ? (
                                  <button className='card-cat-btn2' onClick={() => handlePlaybookClick(narrative.playbook)}>
                                    Playbook <i className="fa-solid fa-book"></i>
                                  </button>
                                ) : null}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                      );
                    })
                  ) : (!serLoading && isSearchActive && (
                    <div className="col-12">
                      <p>No narratives found. Try a different search term.</p>
                      <button className='card-cat-btn1' onClick={handleShowAll}>Show All Narratives</button>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                    </div>
                  )
                  )}
                </div>


              </div>


            ) : (




              <div>
                <div className="hot-narratives-container">
                  <div className="hot-narratives-header">
                    <div>
                      <h1 className="hot-narra-h1-cat">Who are you meeting today?</h1>
                      <p className="hot-narra-p">
                        Select the persona for your demo today and begin your demo journey with Tech Central. 
                         <Link
                          to={`${PATH.SALES_WALKTHROUGH_PATH}?from=menu`}>
                            <span className="sales-question"> How Sales Demos Work?</span>
                        </Link>
                      </p>
                    </div>

                   


                  </div>
                  {/* Hot Narratives Search Bar */}
                  <div className="master-display-two-end-sec">

                  </div>
                </div>



                <div>
                  {salesPersonaResult['persona-details'] && salesPersonaResult['persona-details'].length > 0 ? (
                    <div className="row g-4">
                      {salesPersonaResult['persona-details'].map((item) => (
                        <div className="col-md-3" key={item._id} onClick={() => handleShowSalesFormModel(item._id, item.title)}>
                          <div className="sales-demo-card">
                            <div className="sales-demo-card-image" style={{ backgroundImage: `url(${normalizeMediaUrl(item.thumbnail, 'background')})` }}>
                              <div className="sales-demo-overlay"></div>
                              <h3 className="sales-demo-card-title">{item.title}</h3>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <><p>No Personas Available</p></>
                  )}
                </div>

                <br></br>


              </div>


            )}

          </div>

        </div>
      </div>








      {/* Modal for selecting playbooks if there are multiple */}
      <Modal show={isModalOpen} onHide={closeModal} centered>
        <Modal.Body>
          <button className="close-button-black" onClick={() => closeModal()}><span aria-hidden="true">&times;</span></button><br></br>
          <div class="row">
            {selectedPlaybooks.map((playbook, index) => (
              <div class="col" key={index}>
                <div className="bg-primary-playbook-demo-catal" onClick={() => handlePlaybookSelection(playbook)}>
                  {playbook.title}
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>



      {/* Modal for displaying selected playbook */}
      <Modal
        size="xl"
        show={isPlaybookModalOpen}
        onHide={closePlaybookModal}
        centered>

        <Modal.Body className='content-store-popup'>
          <div className="container">
            <div className='modal-div-learning'>
              <div className="row">
                <div className="col-sm-8 mb-3 mb-sm-0">
                  {selectedPlaybook && (
                    <div className="file-container">
                      <iframe src={normalizeMediaUrl(selectedPlaybook.viewUrl, 'preview')} frameborder="0" width="100%" height="100%" allowfullscreen="true" title="File Preview"></iframe>
                    </div>
                  )}
                </div>
                <div className="col-sm-4 mb-3 mb-sm-0">
                  <div className="file-controls-dive">
                    <h1 className='file-tite-des'>{selectedPlaybook && selectedPlaybook.title}</h1>
                    <div class="line"></div>
                    {/* <p className='file-p-des'>Publish Date : {selectedPlaybook && selectedPlaybook.releaseDate}</p> */}
                    <p className='file-p-des'>Password :
                      <span
                        onClick={() => copyToClipboard('Playbook@123')}
                        style={{ cursor: 'pointer', }}
                        className='passowrd'>
                        Copy Password
                      </span>
                    </p>
                    <button className='card-cat-cancel' onClick={closePlaybookModal}>Back</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


    </>
  );
};

export default Demo_Catalaugue;
